import clsx from "clsx";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { CommunityTagModel } from "../models/CommunityTagModel"
import { defaultProfileImage } from "../../../utils/constants";

type Props = {
    value: CommunityTagModel;
    onRemove: () => void;
    className?: string;
}

export const CommunityTagItem = ({ value, onRemove, className }: Props) => {

    return (
        <div className={clsx("community-tag-item", className)}>
            { value.imageUrl && (
                <img src={toAbsoluteUrl(value.imageUrl) || defaultProfileImage} onError={(e) => { e.currentTarget.src = defaultProfileImage }} alt="Image"/>
            )}
            <span> { value.label } </span>
            <button type="button" onClick={onRemove}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M10.9375 3.0625L3.0625 10.9375" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10.9375 10.9375L3.0625 3.0625" stroke="#B4B4B4" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    )
}